﻿import { leadsPaidCommunitySubmission, leadsPaidPlanSubmission, leadsPaidSpecSubmission } from 'constants/routes';

export const postBuildablePlanBrochure$ = (payload) => {
  const requestObject = {
    'credentials': 'include',
    method: 'POST',
    body: JSON.stringify({
      leadCommand: {
        ...payload,
      },
    }),
    headers: {
      'Content-Type': 'application/json',
    },
    selector: (response) => response.text(),
  };

  fetch(leadsPaidCommunitySubmission, requestObject);
};

export const postCommunityBrochure = (payload) => {
  const requestObject = {
    'credentials': 'include',
    method: 'POST',
    body: JSON.stringify({
      leadCommand: {
        ...payload,
      },
    }),
    headers: {
      'Content-Type': 'application/json',
    },
    selector: (response) => response.text(),
  };

  fetch(leadsPaidCommunitySubmission, requestObject);
};

export const postPlanBrochure = (payload) => {
  const requestObject = {
    'credentials': 'include',
    method: 'POST',
    body: JSON.stringify({
      leadCommand: {
        ...payload,
      },
    }),
    headers: {
      'Content-Type': 'application/json',
    },
    selector: (response) => response.text(),
  };

  fetch(leadsPaidPlanSubmission, requestObject);
};

export const postSpecBrochure = (payload) => {
  const requestObject = {
    'credentials': 'include',
    method: 'POST',
    body: JSON.stringify({
      leadCommand: {
        ...payload,
      },
    }),
    headers: {
      'Content-Type': 'application/json',
    },
    selector: (response) => response.text(),
  };

  fetch(leadsPaidSpecSubmission, requestObject);
};
